import { ReplicaType } from "types";
import Version1 from "./v1";
import Version2 from "./v2";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "daily-prophet-hp7-harry-potter-undesirable-no-1",
  name: `The Daily Prophet\n'Harry Potter Undesirable No.1'`,
  nameFormatted: {
    primary: "The Daily Prophet",
    secondary: "'Harry Potter Undesirable No.1'",
  },
  origin: "Harry Potter and the Deathly Hallows",

  category: replicaCategories.harryPotter,

  versions: [Version2, Version1],
};

export default data;
